module.exports = __webpack_public_path__ + "img/user-edc.ae4c13b3.svg";